import ActionImageSection from './ActionImageSection';
import HighlightedImageSection from './HighlightedImageSection';
import SplitTextImageSection from './SplitTextImageSection';
import TextSection from './TextSection';
import ImageSection from './ImageSection';
import VideoSection from './VideoSection';

module.exports = {
  ActionImageSection,
  HighlightedImageSection,
  SplitTextImageSection,
  TextSection,
  ImageSection,
  VideoSection,
};
